import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-record-title"
}

import { computed } from 'vue'

import { TripFullWithRelations } from '@/models/trip'

import CheckOutItem from '@/components/CheckOutItem.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckOutSection',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const checkOuts = computed(() => props.trip.checkOuts)

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (!checkOuts.value.length)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "No check-out records"))
    : (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "check-out-container"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkOuts.value, (checkOut) => {
            return (_openBlock(), _createBlock(_component_el_col, {
              key: checkOut.id,
              span: 24,
              class: "check-out-col"
            }, {
              default: _withCtx(() => [
                _createVNode(CheckOutItem, {
                  trip: _ctx.trip,
                  checkOut: checkOut
                }, null, 8, ["trip", "checkOut"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
}
}

})